// Hide the legend symbol (29 Oct 2026, Matt's 14 Oct note on the BIPs
// chart: bars coloured by value still showed the series colour in the
// legend). It stays on the DataViz list and only talks: it never opens or
// changes a chart.

import type { Walkthrough } from './types'

export const legendSymbol: Walkthrough = {
  slug: 'legend-symbol',
  title: 'Hide the legend symbol on a chart',
  summary:
    'Shows where to turn off the coloured square before each legend name, so a chart coloured by value keeps its legend text. Nothing is opened or changed.',
  added: '2026-10-29',
  steps: [
    {
      page: 'dashboards',
      feature: 'dataviz/chart-table-editor',
      say: 'Open a dashboard, edit it, and click the pencil on a chart. In the Configuration pane on the right, open Legend.',
    },
    {
      page: 'dashboards',
      feature: 'dataviz/chart-table-editor',
      say: 'Next to Show there is now a Symbol switch. Turn it off and the coloured square before each legend name goes, and the name stays where it was.',
    },
    {
      page: 'dashboards',
      feature: 'dataviz/chart-table-editor',
      say: 'Use it when the colours in the legend mean nothing, as on bars coloured by value. A chart template keeps the setting. A PowerPoint download still draws the square, because PowerPoint has no way to hide it.',
    },
  ],
}
